import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref } from 'vue';
import CatalogItemActions2 from "./CatalogItemActions2.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogItemActions',
    props: {
        item: {},
        cart: {},
        addCartItems: { type: Function },
        addWatchlistItem: { type: Function },
        allowOrderingUnitSelection: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const product = ref(props.item.details.hasOwnProperty('variants') ? props.item.details : undefined);
        const variant = ref(props.item.details.hasOwnProperty('variants') ? product.value.variants[0] : props.item.details);
        return (_ctx, _cache) => {
            return (product.value || variant.value)
                ? (_openBlock(), _createBlock(CatalogItemActions2, {
                    key: 0,
                    product: product.value,
                    "selected-variant": variant.value,
                    cart: __props.cart,
                    "add-cart-items": __props.addCartItems,
                    "add-watchlist-item": __props.addWatchlistItem,
                    "allow-ordering-unit-selection": __props.allowOrderingUnitSelection
                }, null, 8, ["product", "selected-variant", "cart", "add-cart-items", "add-watchlist-item", "allow-ordering-unit-selection"]))
                : _createCommentVNode("", true);
        };
    }
});
